module.exports = __webpack_public_path__ + "static/media/fitinn.80cf7758.jpg";